import React, { useEffect, useState } from 'react';
import { consumirProcessoParaAbrir } from '../../services/processos';
import ProcessosLista from './ProcessosLista';
import ProcessoDetalhe from './ProcessoDetalhe';
import ConfigurarEtapas from './ConfigurarEtapas';

function Processos() {
  const [processoAtivoId, setProcessoAtivoId] = useState(null);
  const [mostrarConfig, setMostrarConfig]      = useState(false);

  /* aberto via drawer "Processos" do Cliente -- viaja pela sessionStorage
     porque este app não tem rota com :id (ver services/processos.js) */
  useEffect(() => {
    const id = consumirProcessoParaAbrir();
    if (id) setProcessoAtivoId(id);
  }, []);

  if (mostrarConfig) {
    return <ConfigurarEtapas onVoltar={() => setMostrarConfig(false)} />;
  }

  return processoAtivoId ? (
    <ProcessoDetalhe processoId={processoAtivoId} onVoltar={() => setProcessoAtivoId(null)} />
  ) : (
    <ProcessosLista onAbrirProcesso={setProcessoAtivoId} onAbrirConfig={() => setMostrarConfig(true)} />
  );
}

export default Processos;
